import {dateTime} from "services/date";
import {FactTemplate} from "types/FactTemplate";

/**
 * Transform the given fact by deserializing object properties
 *
 * @internal
 * @param factTemplate
 */
export default function deserializeFactTemplate(factTemplate: any): FactTemplate {
    factTemplate.created_at = dateTime(factTemplate.created_at)
    factTemplate.updated_at = dateTime(factTemplate.updated_at)

    return factTemplate;
}